import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import FormInputMobile from 'modules/common/components/FormInputMobile';
import DateInputPicker from 'modules/common/components/DateInputPicker';
import Institution from '../components/Institution';
import Profession from '../components/Profession';
import Citizenship from '../components/Citizenship';
import * as actions from '../action';
import * as c from '../constant';

function UpdateModal({
  createInput,
  createSelect,
  updateOhp,
  showTransaction,
  formData,
  updateList,
  setFormData,
  id,
  updating,
  updateBusiness,
  getBusinessEstablishmentsList,
  getInstitutionList,
  getWorkDescriptionList,
  moduleId,
  getCitizenshipList,
}) {

  const setModal = useContext(ModalContext);
  const [formMobile, setFormMobile] = useState({});

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      module_id: moduleId,
      mobile_number: _.get(formMobile, 'mobile_number'),
    };
    updateOhp(id, args, () => {
      setModal({ isOpen: false });
      showTransaction(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  // const onChange = (e) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  // const handleChange = (e) => {
  //   if (isNumber(e.target.value)) {
  //     onChange(e);
  //   }
  // };

  const onSetFormData = () => {
    setFormMobile({
      mobile_number: _.get(updateList, 'mobile_number'),
    });
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        ...updateBusiness,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    getBusinessEstablishmentsList();
    onSetFormData();
    getInstitutionList();
    getWorkDescriptionList();
    getCitizenshipList();
  }, []);

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <label className="col-12 form-group">
            {' '}
            Document Owner&apos;s Information{' '}
          </label>

          <div className="col-4 form-group">
            {createInput({ key: 'first_name', label: 'First Name:' })}
          </div>
          <div className="col-4 form-group">
            {createInput({ key: 'middle_name', label: 'Middle Name:' })}
          </div>
          <div className="col-4 form-group">
            {createInput({ key: 'last_name', label: 'Last Name:' })}
          </div>

          <div className="col-4 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Extension Name',
                key: 'extension_name',
                label: 'Extension Name',
              },
              c.EXTENSION_NAMES
            )}
          </div>
          <div className="col-4 form-group">
            {createSelect(
              {
                key: 'gender',
                label: 'Gender:',
              },
              c.GENDER
            )}
          </div>
          <div className="col-4 form-group">
            {/* <label>Mobile Number:</label>
            <input
              onChange={handleChange}
              className="form-control"
              name="mobile_number"
              type="tel"
              patter=".{12,}"
              maxLength="12"
              value={_.get(formData, 'mobile_number' || '')}
            /> */}
            <label className="form-label">Mobile Number:</label>
            <FormInputMobile
              disableDropdown={false}
              autoComplete="off"
              autoFocus
              type="tel"
              name="mobile_number"
              onChange={setFormMobile}
              value={formMobile.mobile_number || ''}
            />
          </div>
          <div className="col-4 form-group">
            <label>Birth Date:</label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('birth_date')}
              value={_.get(formData, 'birth_date') || ''}
              maxDate={new Date()}
            />
          </div>
          <div className="col-4 form-group">
            {createSelect(
              {
                key: 'civil_status',
                label: 'Civil Status:',
              },
              c.CIVIL_STATUS
            )}
          </div>
          <div className="col-4 form-group">
            {createInput({
              key: 'telephone_number',
              label: 'Telephone Number:',
            })}
          </div>
          <div className="col-6 form-group">
            {createSelect(
              {
                key: 'highest_educational_attainment',
                label: 'Highest Educational Attainment:',
              },
              c.HIGHEST_EDUCATIONAL_ATTAINMENT
            )}
          </div>

          <div className="col-6 form-group">
            <label>Country of Citizenship</label>
            <Citizenship
              name="citizenship_code"
              onChange={handleOnChange}
              value={_.get(formData, 'citizenship_code') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label>Institution</label>
            <Institution
              name="institution_code"
              onChange={handleOnChange}
              value={_.get(formData, 'institution_code') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label>Work Description</label>
            <Profession
              name="work_description_code"
              onChange={handleOnChange}
              value={_.get(formData, 'work_description_code') || ''}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  updateOhp: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  updateBusiness: PropTypes.instanceOf(Object).isRequired,
  getBusinessEstablishmentsList: PropTypes.instanceOf(Function).isRequired,
  getInstitutionList: PropTypes.instanceOf(Function).isRequired,
  getWorkDescriptionList: PropTypes.instanceOf(Function).isRequired,
  moduleId: PropTypes.number.isRequired,
  getCitizenshipList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.EDIT_OHP) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
